/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_ViewingsInputs */

const cs_property_tab_viewings = /** @type {(inputs: Property_Tab_ViewingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prohlídky`)
};

const en_property_tab_viewings = /** @type {(inputs: Property_Tab_ViewingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewings`)
};

/**
* | output |
* | --- |
* | "Viewings" |
*
* @param {Property_Tab_ViewingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_viewings = /** @type {((inputs?: Property_Tab_ViewingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_ViewingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_viewings(inputs)
	return cs_property_tab_viewings(inputs)
});